(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('soopkitchenApp')
        .constant('VERSION', "10.8.0")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
